/* eslint-disable @typescript-eslint/no-explicit-any */
import { message } from "@/components/Base/Message/Message.tsx";
import { toast } from "@/components/Base/Toaster/Toaster";
import { t } from "@/i18n";

//给url加参数，主要将参数用于控制资源缓存
export const urlAddParam = (
  srcUrl: string,
  reqParam: string,
  bIncludeHash = true,
) => {
  if (!srcUrl) {
    return srcUrl;
  }
  const urlArr = srcUrl.split("#");
  let newUrl = urlArr[0];
  if (reqParam) {
    newUrl = newUrl.replace(reqParam, "");
    const pIndex = newUrl.indexOf("?");
    if (pIndex >= 0) {
      newUrl = newUrl.replace(
        "?",
        "?" + reqParam + (pIndex != newUrl.length - 1 ? "&" : ""),
      );
    } else {
      newUrl = urlArr[0] + "?" + reqParam;
    }
  }
  if (bIncludeHash) {
    const urlHash = urlArr.length > 1 ? "#" + urlArr[1] : "";
    newUrl += urlHash;
  }
  return newUrl;
};
//将自身的持久化url参数加到分享链接上
export const addMyUrlParamToLink = (link: any) => {
  if (link.startsWith("http")) {
    //上级复制链接给下级，自动加上自己的一些url参数
    let urlParams = "";
    const urlCodes: any = {};
    const keyArr = ["gtk"];
    keyArr.forEach((ele) => {
      if (urlCodes.value[ele]) {
        if (urlParams) {
          urlParams += "&";
        }
        urlParams += ele + "=" + urlCodes.value[ele];
      }
    });
    link = urlAddParam(link, urlParams);
  } else {
    toast.error("addMyUrlParamToLink link is wrong, link:" + link);
  }
  return link;
};
//复制文本功能
export const copyText = (
  text: any,
  bUrlParams = false,
  showToast = true,
  toastText = t("toast.copied") + "!",
) => {
  if (!text) {
    return;
  }
  if (bUrlParams) {
    //上级复制链接给下级，自动加上自己的一些url参数
    text = addMyUrlParamToLink(text);
  }

  //方案一
  const domInput = document.createElement("textarea"); // textarea复制内容支持换行
  domInput.setAttribute("readonly", "readonly");
  domInput.style.position = "absolute";
  domInput.style.left = "-10000px";
  domInput.style.zIndex = "-1";
  domInput.value = text;
  document.body.appendChild(domInput); // 添加input节点
  domInput.select(); // 选择对象;
  document.execCommand("Copy"); // 执行浏览器复制命令
  domInput.remove();
  if (showToast) {
    message.show(toastText);
  }
};
